import { landerApiSendLead } from '@/shared/lib/domains/lander/landerApiSendLead';
import {
  commonObjectUnref,
  RefsMap,
} from '@/shared/lib/domains/common/commonObjectUnref';
import { commonSentryCaptureException } from '@/shared/lib/domains/common/commonSentryCaptureException';
import { RuntimeError } from '@/shared/lib/core/errors';
import { $t } from '@/shared/helpers/i18n';
import {
  landerSourceName,
  landerUtmSource,
} from '@/shared/lib/domains/lander/landerConstants';
import {
  projectName,
  projectNames,
} from '@/shared/constants/system';

export const landMap = {
  [projectNames.MTI]: 'mc_referral',
  [projectNames.MOSAP]: 'mt_referral',
  [projectNames.SF]: 'sf_referral',
  [projectNames.PEOPLE]: 'sp_referral',
};

export async function inviteSetupFormSubmit(payload: RefsMap) {
  try {
    return await landerApiSendLead({
      params: {
        land: landMap[projectName] ?? 'sf_referral',
        sourceName: landerSourceName,
        utm_source: landerUtmSource,
      },
      payload: {
        ...commonObjectUnref(payload),
      },
    },
    true,
    'SFR',
    );
  } catch (e) {
    commonSentryCaptureException(e, 'сетап инвайта сф');
    throw new RuntimeError(`${$t('general.error_occured')} ${$t('general.try_again')}`);
  }
}
